import { render } from "./abilityNumber.vue?vue&type=template&id=85628592&scoped=true"
import script from "./abilityNumber.vue?vue&type=script&lang=js"
export * from "./abilityNumber.vue?vue&type=script&lang=js"

import "./abilityNumber.vue?vue&type=style&index=0&id=85628592&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85628592"]])

export default __exports__